module.exports = __webpack_public_path__ + "img/GiG.234eebe.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/integrations/GiG.png
// module id = AQYf
// module chunks = 38 43